import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { t } from 'i18next';

import { arrayHasLength } from '~utils/array';
import { formatPrice } from '~utils/number';

import styles from './styles.module.scss';

export const InfoBadgePromo = ({ cartItem, isCheckout, totalSaved }) => {
  const actualPromos = useSelector(state => state.promoSelling.actualPromos);

  if (arrayHasLength(actualPromos) && !actualPromos[0].checked && !isCheckout && !cartItem) {
    return (
      <span className={styles.promoSelling}>
        {t('PromoSelling:existsPromos', { value: formatPrice(actualPromos[0].savedPrice) })}
      </span>
    );
  }

  if (cartItem?.offerId && cartItem?.discount > 0) {
    return (
      <span className={`${styles.promoSelling} ${styles.cartItem}`}>
        {cartItem.appliedPromos.discount
          ? t('PromoSelling:discountPriceSummaryPercentage', {
              value: `${cartItem.appliedPromos.discount.slice(0, -1)}`
            })
          : t('PromoSelling:discountPrice', { value: formatPrice(cartItem.discount) })}
      </span>
    );
  }

  if (isCheckout && totalSaved > 0) {
    return (
      <span className={`${styles.promoSelling} ${styles.checkout}`}>
        {t('PromoSelling:discountPriceSummary', { value: formatPrice(totalSaved) })}
      </span>
    );
  }

  return null;
};

InfoBadgePromo.propTypes = {
  cartItem: PropTypes.object,
  isCheckout: PropTypes.bool,
  totalSaved: PropTypes.number
};
